import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import { SOFTLINE_API_MDE_SCAN_LAGER } from '../einseitige-lagerbuchung.api';
import { Lagerstamm } from '../models/lagerstamm';

@Injectable()
export class LagerScanRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  async scan(code: string): Promise<Lagerstamm> {
    return this.dataAccess.get<Lagerstamm>({
      path: SOFTLINE_API_MDE_SCAN_LAGER,
      pathParams: { code },
    });
  }
}
